/* Native product/variant IDs remain authoritative. Full variant navigation avoids
   cross-template section fetches and keeps title, gallery and cart forms together. */
(()=>{if(!document.querySelector('#lp-category-style'))return;
document.addEventListener('change',event=>{
 const control=event.target;if(!(control instanceof HTMLInputElement||control instanceof HTMLSelectElement))return;
 const picker=control.closest('variant-selects');if(!picker)return;
 const root=picker.closest('product-info');if(!root)return;
 let variants;try{variants=JSON.parse(document.querySelector('[data-mf-variants]').textContent)}catch{return}
 const groups=[...picker.querySelectorAll('.product-form__input')];
 const chosen=groups.map(g=>g.querySelector('select')?.value||g.querySelector('input:checked')?.value);
 const variant=variants.find(v=>v.options?.every((value,index)=>String(value)===String(chosen[index])));
 if(!variant)return;
 event.stopImmediatePropagation();
 const next=new URL(root.dataset.url||location.pathname,location.origin);next.searchParams.set('variant',variant.id);
 const view=new URLSearchParams(location.search).get('view');if(/^lp-[abcd](?:-preview)?$/.test(view||''))next.searchParams.set('view',view);
 if(next.href!==location.href)location.assign(next.href);
},true);
})();
